module.exports = __webpack_public_path__ + "static/media/l1.d22f0535.png";